import type { ElementType } from "react";
import { ClipboardList, Link2, PenLine } from "lucide-react";

/**
 * One section of a patient's workspace, and the route path segment for it.
 * `connections` is not a rail tab, only a route.
 */
export type PatientSectionId = "summary" | "onboarding" | "connections";

/** One entry in the patient rail. */
export type PatientSectionNavItem = {
  id: PatientSectionId;
  label: string;
  icon: ElementType;
  /** Renders as a right-aligned count when set. */
  badge?: number;
  /** Renders as a dot when true, for sections holding something unread. */
  dot?: boolean;
};

/** Which of the two Onboarding tabs is showing. Doubles as the URL segment. */
export type OnboardingTabId = "setup" | "connected-systems";

/** Fixed order of the patient rail. Badges are filled from the summary query. */
export const PATIENT_SECTIONS: Omit<PatientSectionNavItem, "badge" | "dot">[] = [
  { id: "summary", label: "Summary", icon: ClipboardList },
  { id: "onboarding", label: "Onboarding", icon: PenLine },
];

/** The same sections for an individual workspace, where onboarding means connecting the owner's own hospitals. */
export const INDIVIDUAL_PATIENT_SECTIONS: Omit<PatientSectionNavItem, "badge" | "dot">[] = [
  { id: "summary", label: "Summary", icon: ClipboardList },
  { id: "onboarding", label: "Connect health systems", icon: Link2 },
];

/** Fixed order and labels of the Onboarding tabs. The first is the default. */
export const ONBOARDING_TABS: readonly { id: OnboardingTabId; label: string }[] = [
  { id: "setup", label: "Setup" },
  { id: "connected-systems", label: "Connected systems" },
];

/** The tab a bare `/onboarding` and any unknown tab segment land on. */
export const DEFAULT_ONBOARDING_TAB: OnboardingTabId = "setup";
